import React from "react"
import { DialogTitle as Title } from "@material-ui/core"
import { DialogTitleCloser } from "../Creators/DialogTitleCloser"
import { InlineTitle } from "../Creators/InlineTitle"
import { InlineTitleCloser } from "../Creators/InlineTitleCloser"

const DialogTitle = ({ id = "form-dialog-title", children, isInline = false, onClose, className, ...rest }) => {
  if (isInline) {
    return (
      <InlineTitle id={id} {...rest} className={className}>
        {children}
        <InlineTitleCloser onClose={onClose} />
      </InlineTitle>
    )
  }

  return (
    <Title id={id} {...rest} className={className}>
      {children}
      <DialogTitleCloser onClose={onClose} />
    </Title>
  )
}

export { DialogTitle }
